import React from "react";
import { TimelineList } from "./TimelineList";

const formatDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  return date.toLocaleDateString("en-US", {
    month: "short",
    year: "numeric",
  });
};

export const Experience = ({ data }) => (
  <TimelineList
    items={(data?.work_experience || [])
      .map((item) => {
        const subtitleParts = [item.company, item.location].filter((val) => val && val.trim() !== "");

        return {
          title: item.title || "",
          subtitle: subtitleParts.length ? subtitleParts.join(" · ") : null,
          duration: item.start_date || item.end_date ? `${formatDate(item.start_date)} – ${item.end_date !== "present" ? formatDate(item.end_date) : "Present"}` : null,
          description: item.description || null,
        };
      })
      .filter((item) => item.title?.trim() || item.subtitle?.trim() || item.duration?.toString().trim() || item.description?.trim())}
    dotColor="#2563EB"
  />
);

export default Experience;
